// src/ConsumerApp/Screens/Account/AccountLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../../DesignSystem/Navigation/Navbar';
import CenteredContainer from '../../DesignSystem/Layout/CenteredContainer';
import AccountSidebar from './AccountSidebar';

export default function AccountLayout() {
  return (
    <div style={styles.pageShell}>
      <Navbar />

      <CenteredContainer>
        <div style={styles.layoutRow}>
          {/* Left Column: Fixed Sidebar */}
          <aside style={styles.leftCol}>
            <AccountSidebar />
          </aside>

          {/* Right Column: Dynamic View (Orders, Profile, Delivery, etc.) */}
          <main style={styles.rightCol}>
            <Outlet />
          </main>
        </div>
      </CenteredContainer>
    </div>
  );
}

const styles = {
  pageShell: {
    backgroundColor: '#FAF9F6',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  layoutRow: {
    display: 'flex',
    gap: 28,
    padding: '24px 0 48px 0',
    alignItems: 'flex-start',
    width: '100%',
  },
  leftCol: {
    width: 320,
    flexShrink: 0,
    position: 'sticky',
    top: 96,
  },
  rightCol: {
    flex: 1,
    minWidth: 0,
  },
};